import React, { useEffect } from "react";
import { removeTawkArtifacts } from "src/marketConnect/helpers/crud-helper/cookieHelpers";

export function TwakScript({ isShow = true }: { isShow?: boolean }) {
  useEffect(() => {
    if (!isShow) {
      removeTawkArtifacts();
      return;
    }

    // Start of Tawk.to Script
    if (process.env['REACT_APP_ENV'] === 'production') {
      const existingScript = document.getElementById("tawk-script");
      if (existingScript) {
        return;
      }

      // Initialize Tawk variables on the global window object to prevent bootstrapping/initialization failures
      const win = window as any;
      win.Tawk_API = win.Tawk_API || {};
      win.Tawk_LoadStart = new Date();

      const script = document.createElement("script");
      script.id = "tawk-script";
      script.async = true;
      script.src = 'https://embed.tawk.to/660663bda0c6737bd126275f/1hq4fb753';
      script.charset = 'UTF-8';
      script.setAttribute('crossorigin', '*');
      document.body.appendChild(script);
    }
  }, [isShow]);

  return null;
}